import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const AdminLogin = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login fehlgeschlagen");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full bg-[#1A1A1A] border border-white/10 text-white p-4 focus:border-[#ff0033] outline-none transition-colors placeholder:text-neutral-600";
  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-[#050505]" data-testid="admin-login">
      <div className="w-full max-w-md bg-[#0F0F0F] border border-white/10 p-8">
        <div className="flex items-center gap-3 mb-2"><Lock size={20} className="text-[#ff0033]" /><span className="font-mono-lab text-xs tracking-[0.2em] text-neutral-500 uppercase">Admin · Coach Login</span></div>
        <h1 className="font-heading text-3xl uppercase tracking-tight text-white mb-6">GOLFCOACHING<span className="text-[#ff0033]">.</span>ACADEMY</h1>
        <form onSubmit={submit} className="space-y-4">
          <input data-testid="login-email" type="email" placeholder="E-Mail" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} required />
          <input data-testid="login-password" type="password" placeholder="Passwort" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} required />
          <button data-testid="login-submit" disabled={loading} className="w-full bg-[#ff0033] text-white font-heading uppercase tracking-wider py-4 hover:bg-[#cc0029] transition-colors flex items-center justify-center gap-2 disabled:opacity-60">
            {loading ? <Loader2 className="animate-spin" size={20} /> : "Anmelden"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
